(function () {
	const header = () => {
		const body = document.querySelector("body");
		const header = document.querySelector(".shopify-section-header");
		const headerDetails = document.querySelector(".menu-drawer-container");

		if (!header || !headerDetails) return;

		const headerWrapper = header.querySelector(".header-wrapper");
		const headerIsAlwaysSticky =
			headerWrapper && headerWrapper.getAttribute("data-sticky-type") === "always";

		// Toggle color scheme on drawer open/close
		headerDetails.addEventListener("toggle", function () {
			const menuDrawer = this.querySelector("#menu-drawer");
			if (!menuDrawer) return;

			const colorScheme = menuDrawer.dataset.colorScheme;
			if (!colorScheme) return;

			header.classList.toggle(colorScheme);
		});

		// Close on ESC
		document.addEventListener("keyup", (e) => {
			if (e.key === "Escape") {
				header.classList.remove("shopify-section-header-sticky", "animate");
				body.classList.remove("overflow-hidden");
			}
		});

		// Sticky behavior
		document.addEventListener("scroll", () => {
			if (!headerIsAlwaysSticky) return;

			const scrollTop = window.scrollY;
			if (scrollTop > header.offsetHeight) {
				header.classList.add("fixed", "animate");
			} else {
				header.classList.remove("fixed", "animate");
			}
		});

		const addBackground = () => {
			if (
				header.classList.contains("color-inverse") &&
				!header.classList.contains("shopify-section-header-sticky")
			) {
				header.classList.remove("color-inverse");
			}
		};

		const removeBackground = () => {
			if (document.body.classList.contains("overflow-hidden-tablet")) return;

			if (
				header.classList.contains("header-overlay") &&
				!header.classList.contains("shopify-section-header-sticky")
			) {
				header.classList.add("color-inverse");
			}
		};

		header.addEventListener("mouseenter", addBackground);
		header.addEventListener("focus", addBackground);
		header.addEventListener("focusin", addBackground);
		header.addEventListener("mouseleave", removeBackground);
		header.addEventListener("focusout", removeBackground);

		/**
		 * FIX: allow clicking parent menu item (that has submenu) to navigate
		 * while keeping arrow/toggle to open submenu.
		 *
		 * Requirements in markup:
		 * - Parent link has class ".menu-drawer__menu-link"
		 * - Arrow/toggle wrapper has class ".menu-drawer__submenu-toggle"
		 */
		document.addEventListener("click", (e) => {
			const link = e.target.closest(".menu-drawer__menu-link");
			if (!link) return;

			// If user clicked arrow/toggle zone, don't navigate
			if (e.target.closest(".menu-drawer__submenu-toggle")) return;

			// If link is inside <summary>, prevent <summary> toggle from swallowing the click
			const summary = link.closest("summary");
			if (summary) {
				e.preventDefault();
				e.stopPropagation();
				window.location.href = link.href;
			}
		});
	};

	// Run once
	header();

	// Shopify events
	document.addEventListener("shopify:section:load", header);
	document.addEventListener("shopify:section:unload", header);
	document.addEventListener("shopify:section:reorder", header);
})();
